import React, { useState, useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Sun, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, login, error } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await login(email.trim(), password);
    setLoading(false);
    if (ok) {
      toast.success("Welcome back, Admin ☀");
      navigate("/admin", { replace: true });
    } else {
      toast.error("Login failed");
    }
  };

  return (
    <div className="min-h-screen hero-radial grid place-items-center p-6">
      <div className="w-full max-w-md rounded-3xl bg-white border border-stone-200 shadow-xl overflow-hidden">
        <div className="bg-green-700 text-white p-6">
          <Link
            to="/"
            className="inline-flex items-center gap-1 text-green-100 text-xs mb-4 hover:text-yellow-300"
            data-testid="admin-back-home"
          >
            <ArrowLeft className="w-3.5 h-3.5" /> Back to site
          </Link>
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 rounded-xl bg-white grid place-items-center p-1">
              <img src="/purvodaya-logo.png" alt="Purvodaya Solar" className="w-full h-full object-contain" />
            </div>
            <div>
              <div className="font-display font-extrabold text-lg">
                Purvodaya <span className="text-orange-300">Admin</span>
              </div>
              <div className="text-[11px] uppercase tracking-[0.18em] text-yellow-300">
                Leads & Dashboard
              </div>
            </div>
          </div>
        </div>
        <form onSubmit={submit} className="p-6 space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="admin-email"
              className="mt-1.5"
              placeholder="Email ID"
            />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="admin-password"
              className="mt-1.5"
              placeholder="••••••••"
            />
          </div>
          {error ? (
            <div
              className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2"
              data-testid="admin-error"
            >
              {error}
            </div>
          ) : null}
          <Button
            type="submit"
            disabled={loading}
            data-testid="admin-submit"
            className="w-full h-11 rounded-full bg-green-600 hover:bg-green-700 text-white font-semibold"
          >
            {loading ? "Signing in…" : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
}
